import {Component, Input, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {ErrorHandlingService} from '../../provider/error-handling/error-handling.service';
import {ALERT_TXT, TOAST_TXT} from '../../strings/language';
import {StorageService} from '../../provider/storage/storage.service';
import {ConfigurationObject} from '../../interfaces/interfaces.regisafe';
import {DateiSystemService} from '../../provider/datei-system/datei-system.service';
import {APP_ASSIGN_FOLDER, APP_EDIT_FOLDER, APP_STORAGE} from '../../../environments/environment';
import {AlertController} from '@ionic/angular';
import {AppConfig} from '../../app.config';

@Component({
	selector: 'app-regisafe-reset-config',
	templateUrl: './regisafe-reset-config.component.html',
	styleUrls: ['./regisafe-reset-config.component.scss'],
})
export class RegisafeResetConfigComponent implements OnInit {

	public configuration: ConfigurationObject;
	public resetForm: FormGroup = this.fb.group({});
	jsonData: any;
	alert: HTMLIonAlertElement;
	placeholderConfig = {
		iqapiAppId: '',
		iqapiDomain: '',
		iqapiEndpoint: ''
	};

	constructor(private httpClient: HttpClient,
				private fb: FormBuilder,
				private errorHandling: ErrorHandlingService,
				private storageService: StorageService,
				private dateiService: DateiSystemService,
				private appConfig: AppConfig,
				private alertCtrl: AlertController) {
		this.configuration = this.appConfig.getConfig();

		this.placeholderConfig.iqapiAppId = this.configuration.iqapiAppId;
		this.placeholderConfig.iqapiDomain = this.configuration.iqapiDomain;
		this.placeholderConfig.iqapiEndpoint = this.configuration.iqapiEndpoint.substring(this.configuration.iqapiEndpoint.lastIndexOf('/') + 1, this.configuration.iqapiEndpoint.length);

		console.log('configuration: ', this.configuration);
	}

	async ngOnInit() {
		this.jsonData = await this.getJsonData()
			.toPromise();
		if (this.jsonData.hasOwnProperty('controls')) {
			this.createForm(this.jsonData.controls);
		}
	}

	getJsonData(): Observable<any> {
		return this.httpClient
			.get('assets/static-data/app.resetform.json');
	}

	createForm(controls: Array<any>) {
		for (const control of controls) {
			const validatorsToAdd = [];
			for (const [key, value] of Object.entries(control.validators)) {
				switch (key) {
					case 'required':
						if (value) {
							validatorsToAdd.push(Validators.required);
						}
				}
			}

			this.resetForm.addControl(control.name, this.fb.control('', validatorsToAdd));
		}
	}

	async onSubmit() {

		console.log('Lorem: ', this.resetForm.valid);
		
		if (!this.resetForm.valid) {
			this.errorHandling.errorMessage(TOAST_TXT.message.str00030, 'toast', false);
			return false;
		}

		this.alert = await this.alertCtrl.create({
			header: ALERT_TXT.header.str00010,
			subHeader: ALERT_TXT.subHeader.str00110,
			buttons: [{
				text: ALERT_TXT.buttons.str00010,
				role: 'cancel'
			}, {
				text: ALERT_TXT.buttons.str00070,
				handler: () => {
					if (this.resetForm.valid) {
						const formValue = JSON.parse(JSON.stringify(this.resetForm.value));
						formValue.iqapiDomain = this.removeTrailingSlash(formValue.iqapiDomain) + '/';
						formValue.iqapiEndpoint = formValue.iqapiDomain + this.removeAllSlashes(formValue.iqapiEndpoint);
						this.rewriteConfiguration(formValue);
					} else {
						this.errorHandling.errorMessage(TOAST_TXT.message.str00030, 'toast', false);
					}
				}
			}]
		});

		this.alert.present();

	}

	removeTrailingSlash(str): string {
		return str.replace(/\/+$/, '');
	}

	removeAllSlashes(str): string {
		return str.replace(/\//g,'');
	}

	async rewriteConfiguration(values: ConfigurationObject) {
		// localstorage überschreiben
		this.storageService.setAppConfigurationSync(values);
		const editfolder = await this.dateiService.leseDateienInOrdner(APP_EDIT_FOLDER);
		// Ordner  mit Dateien löschen
		if (editfolder.files.length > 0) {
			await this.deletFolders(APP_EDIT_FOLDER, editfolder.files);
		}
		const assignfolder = await this.dateiService.leseDateienInOrdner(APP_ASSIGN_FOLDER);
		if (editfolder.files.length > 0) {
			await this.deletFolders(APP_ASSIGN_FOLDER, assignfolder.files);
		}


		// configuration Object zurücksetzen


		// DB löschen
		this.storageService.removeToken();
		this.storageService.removeConditions();
		this.storageService.removeItemFromStorage(APP_STORAGE.user.locked);
		this.storageService.removeItemFromStorage(APP_STORAGE.user.edit);
		this.storageService.removeItemFromStorage(APP_STORAGE.searchforms);
		this.storageService.removeItemFromStorage(APP_STORAGE.user.username);

		setTimeout(() => {
			window.location.assign('/');
		}, 500);
	}

	async deletFolders(root, folders) {
		if (folders.length < 1) {
			return false;
		}
		const loesche = await this.dateiService.loescheOrdner(root + folders[0]);
		if (loesche) {
			folders.splice(0, 1);
			this.deletFolders(root, folders);
		}
	}


}
